import { BUILD_LOCALE } from '../ots-constants';

export const dir = './public/locales';
export const targetTypes = './src/i18n/translations.d.ts';
export const targetTranslations = './src/i18n/translations.generated.ts';

export const defaultLocale = 'en';
export const locale = BUILD_LOCALE || defaultLocale;
